import { render } from "./SellerCategories.vue?vue&type=template&id=6ce74526&scoped=true"
import script from "./SellerCategories.vue?vue&type=script&lang=js"
export * from "./SellerCategories.vue?vue&type=script&lang=js"

import "./SellerCategories.vue?vue&type=style&index=0&id=6ce74526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce74526"]])

export default __exports__